import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommFilterJunctionUserTable extends Layout {
    sourceMCFilterJunctionUser: DataSource;
    tableMCFilterJunctionUser: Table;
}
